import { render, staticRenderFns } from "./ChatsListItem.vue?vue&type=template&id=0e497a49&scoped=true&"
import script from "./ChatsListItem.vue?vue&type=script&lang=js&"
export * from "./ChatsListItem.vue?vue&type=script&lang=js&"
import style0 from "./ChatsListItem.vue?vue&type=style&index=0&id=0e497a49&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e497a49",
  null
  
)

export default component.exports